export const SERVER_IP = window.location.origin
export const CLIENT_IP = window.location.origin
